export default {
  get_promo_by_code: (code) => `https://themantra.shop/api/promo/?code=${code}`,
  unsubscribe_promo_mailing: (subscribeId) => `https://themantra.shop/api/subscribe/${subscribeId}/unsubscribe/`,
  get_client: (id) => `https://themantra.shop/api/client/${id}/`,
  activate_promo: 'https://themantra.shop/api/promo_active/',
  patch_active_promo: (id) => `https://themantra.shop/api/promo_active/${id}/`,
}
